import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Soal from "../../Components/Soal/Soal";
import "./Answer.css";
import Header from "../../Components/Header/Header";

function Answer() {
  const [data, setData] = useState([]);

  const location = useLocation();

  const userKeyHandler = (id, user_key_state) => {
    return 0;
  };

  const [finalTheme, setFinalTheme] = useState("");

  const finalThemeHandler = (theme) => {
    setFinalTheme(theme);
  };

  useEffect(() => {
    const { data, defaultTheme } = location.state;
    setData(data);

    setFinalTheme(defaultTheme);
  }, []);

  const { defaultTheme } = location.state

  return (
    <div class="shah_kelid_soal">
      <div class="main_container">
      <Header defaultTheme={defaultTheme} finalThemeHandler={finalThemeHandler}></Header>

        {data.map((item, index) => (
          <Soal
            key={item.id}
            key_soal={item.key}
            {...item}
            num={index}
            userKeyHandler={userKeyHandler}
            isAnswerPage={true}
          />
        ))}
      </div>
    </div>
  );
}

export default Answer;
